import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { fetchEndpointIfNeeded } from '../../actions/fetch'

const UserDropdown = ({
    endpointName,
    endpoints,
    dispatch,
    onChange,
    value,
    id,
    name,
    className,
    showInactive,
    disabled,
    fallBackToText
}) => {
    let selectDom = null
    let finalFallBackToText = fallBackToText !== undefined ? fallBackToText : true

    let epList = []


    let foundEndpoint = endpoints.find(elem =>
        elem.name === endpointName
    )
    if (foundEndpoint) {
        if (foundEndpoint.list.length === 0) {
            dispatch(fetchEndpointIfNeeded(foundEndpoint.id))
        }
        if (foundEndpoint.list.length > 0) {
            epList = foundEndpoint.list
                .filter(fep => {
                    if (showInactive === false && (fep.hasOwnProperty('status') && !fep.status)) {
                        // do not include in the options if endpoint has status field and it is set to 0 or false
                        return false
                    } else {
                        return true
                    }
                })
                .map(fep => {
                    return {
                        id: fep.id,
                        name: fep.username || fep.description || fep.id
                    }
                })
        }
    }
    if (value === null) {
        value = ""
    }
    let currentValueIsUnknown = false
    let eplName = '';
    if (value && epList.length > 0) {
        let currentValSelected = epList.find(ep => ep.id === Number(value))
        if (!currentValSelected) {
            currentValueIsUnknown = true
        } else {
            eplName = currentValSelected.name;
        }
    }

    if (disabled == 'disabled') {
        selectDom = <div>
                        <label>{eplName}</label>
                    </div>
    } else {
        // Create the drop down.
        if (epList.length > 0) {
            selectDom = <select disabled={disabled} value={value} onChange={onChange} id={id} name={name} className={className || "form-control"} >
                <option value=""></option>
                {
                    epList.map(epl => <option key={epl.id} value={epl.id}>{epl.name}</option>)
                }
                {currentValueIsUnknown &&
                    <option value={value}> Inactive</option>
                }
            </select>
        } else {
            if (finalFallBackToText) {
                selectDom = <input
                    disabled={disabled}
                    type="text"
                    id={id}
                    className={className || "form-control"}
                    value={value}
                    onChange={onChange} />
            } else {
                selectDom = (
                    <select disabled={disabled} value={value} onChange={onChange} id={id} name={name} className={className || "form-control"} >
                        <option value="">No {endpointName} available</option>
                        {value &&
                            <option value={value}>DELETED ({value})</option>
                        }
                    </select>
                )
            }
        }
    }

    return selectDom
}

function mapStateToProps(state, ownProps) {
    // default to false if not specified
    let showInactive = ownProps.hasOwnProperty("showInactive") ? ownProps.showInactive : false

    return {
        endpoints: state.endpoints,
        onChange: ownProps.onChange,
        endpointName: ownProps.endpointName,
        value: ownProps.value,
        id: ownProps.id,
        name: ownProps.name,
        showInactive
    }
}

export default withRouter(connect(mapStateToProps)(UserDropdown))


// WEBPACK FOOTER //
// ./src/components/utilities/UserDropdown.js